import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Modal from '../modal/Modal';
import { AuthenticationState } from 'react-aad-msal';
import { IoMdClose } from 'react-icons/io';
import { connect } from 'react-redux';
import { loyaltyDuck } from '../../ducks/loyalty';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import redPeg from '../../images/svg/red-peg.svg';
import yellowPeg from '../../images/svg/yellow-peg.svg';
import bluePeg from '../../images/svg/blue-peg.svg';

var PegLevelReachedOverlay = function PegLevelReachedOverlay(props) {
  var _Copy$value;

  var authenticationState = props.authenticationState;
  var _props$model = props.model,
      BackgroundShape = _props$model.BackgroundShape,
      Header = _props$model.Header,
      Copy = _props$model.Copy,
      _props$model$Availabi = _props$model.Availability,
      Availability = _props$model$Availabi === void 0 ? true : _props$model$Availabi;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      balance = _useState4[0],
      setBalance = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      redPegs = _useState6[0],
      setRedPegs = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      yellowPegs = _useState8[0],
      setYellowPegs = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      bluePegs = _useState10[0],
      setBluePegs = _useState10[1];

  var _useState11 = useState(100),
      _useState12 = _slicedToArray(_useState11, 2),
      vh = _useState12[0],
      setVh = _useState12[1]; // Default value


  useEffect(function () {
    var updateViewportHeight = function updateViewportHeight() {
      var newVh = window.innerHeight;
      setVh(newVh);
    };

    updateViewportHeight();
    window.addEventListener('resize', updateViewportHeight);
    return function () {
      window.removeEventListener('resize', updateViewportHeight);
    };
  }, []);
  useEffect(function () {
    var isMobileQuery = window.matchMedia('(max-width: 768px)');
    var items = isMobileQuery.matches ? 20 : 30;
    var redPegsAux = [];
    var yellowPegsAux = [];
    var bluePegsAux = [];

    for (var i = 0; i < items; i++) {
      redPegsAux.push( /*#__PURE__*/React.createElement("img", {
        key: "".concat(i, "--red"),
        className: "animated-falling-red-peg-".concat(i),
        src: redPeg,
        alt: 'Red Peg'
      }));
      yellowPegsAux.push( /*#__PURE__*/React.createElement("img", {
        key: "".concat(i, "--yellow"),
        className: "animated-falling-yellow-peg-".concat(i),
        src: yellowPeg,
        alt: 'Yellow Peg'
      }));
      bluePegsAux.push( /*#__PURE__*/React.createElement("img", {
        key: "".concat(i, "--blue"),
        className: "animated-falling-blue-peg-".concat(i),
        src: bluePeg,
        alt: 'Blue Peg'
      }));
    }

    setRedPegs(redPegsAux);
    setYellowPegs(yellowPegsAux);
    setBluePegs(bluePegsAux);
  }, []);

  var checkPegLevelReached = function checkPegLevelReached(account) {
    if ((account === null || account === void 0 ? void 0 : account.Balance) && parseInt(account.Balance) > 0) {
      var balanceRanges = [75, 150, 225];
      var accountBalance = account.Balance;
      var closestLowerRange = null;

      for (var _i = 0, _balanceRanges = balanceRanges; _i < _balanceRanges.length; _i++) {
        var balanceRange = _balanceRanges[_i];

        if (accountBalance >= balanceRange) {
          closestLowerRange = balanceRange;
        } else {
          break; // Exit the loop when the condition is no longer met
        }
      }

      if (closestLowerRange !== null) {
        setBalance(closestLowerRange);
      }
    }
  };

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _props$loyalty;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(authenticationState !== AuthenticationState.Authenticated)) {
                _context.next = 4;
                break;
              }

              setIsOpen(false);
              _context.next = 18;
              break;

            case 4:
              if (!(props.loyalty.showPersonalizationModal === 'pegLevelReached')) {
                _context.next = 18;
                break;
              }

              checkPegLevelReached((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : _props$loyalty.account);

              if (!(Availability === null || Availability === void 0 ? void 0 : Availability.value)) {
                _context.next = 10;
                break;
              }

              setIsOpen(true);
              _context.next = 18;
              break;

            case 10:
              _context.prev = 10;
              _context.next = 13;
              return props.checkPersonalizationOverlays(['pegLevelReached']);

            case 13:
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](10);
              console.error('Error checking personalization overlays', _context.t0.message);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 15]]);
    }))();
  }, [props.loyalty]);

  var handleHide = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsOpen(false);
              _context2.prev = 1;
              _context2.next = 4;
              return props.setPersonalizationModals(null);

            case 4:
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              console.error('Error closing personalization modal', _context2.t0.message);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 6]]);
    }));

    return function handleHide() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var handleTouchMove = function handleTouchMove(e) {
      if (isOpen) {
        e.preventDefault();
      }
    };

    window.addEventListener('touchmove', handleTouchMove, {
      passive: false
    });
    return function () {
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(Modal, {
    className: 'peg-level-reached-overlay',
    show: isOpen,
    hide: handleHide,
    hideCloseButton: false,
    backdrop: false,
    size: 'lg'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'peg-level-reached-overlay__container',
    onClick: handleHide,
    style: {
      'height': "".concat(vh, "px")
    }
  }, redPegs, yellowPegs, bluePegs, /*#__PURE__*/React.createElement("button", {
    className: "peg-level-reached-overlay__close",
    onClick: handleHide
  }, /*#__PURE__*/React.createElement(IoMdClose, null)), /*#__PURE__*/React.createElement("div", {
    className: 'peg-level-reached-overlay__body'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'peg-level-reached-overlay__peg-counter-container'
  }, /*#__PURE__*/React.createElement(Image, {
    field: BackgroundShape,
    className: "peg-level-reached-overlay__peg-counter-bg-image"
  }), /*#__PURE__*/React.createElement("span", {
    className: 'peg-level-reached-overlay__peg-counter'
  }, balance)), /*#__PURE__*/React.createElement("span", {
    className: 'peg-level-reached-overlay__header'
  }, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("span", {
    className: 'peg-level-reached-overlay__copy'
  }, Copy === null || Copy === void 0 ? void 0 : (_Copy$value = Copy.value) === null || _Copy$value === void 0 ? void 0 : _Copy$value.replace('#pegs', balance)))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loyalty: state.loyalty
  };
};

var loyaltyOperations = loyaltyDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPersonalizationModals: function setPersonalizationModals(show) {
      return dispatch(loyaltyOperations.setPersonalizationModals(show));
    },
    checkPersonalizationOverlays: function checkPersonalizationOverlays(disabledOverlays) {
      return dispatch(loyaltyOperations.handleCheckPersonalizationOverlays(disabledOverlays));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PegLevelReachedOverlay);